import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconRoller: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRoller"><Circle cx="5.5" cy="16.5" r="3" stroke="currentColor"/><Circle cx="18.5" cy="16.5" r="3" stroke="currentColor"/><Path d="M8.5 16.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 4.5H16.5L18 13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRoller;
